@if(rol$ | async; as rol){
    <div class="w-full bg-white px-4 md:px-8 h-screen flex flex-col">

        <!-- Header -->
        <div class="flex flex-row justify-between items-center py-3 border-b shrink-0">

            <!-- Title -->
            <div class="w-full flex items-center">
                <arrow-back></arrow-back>
                <div>
                    <div class="text-2xl font-extrabold leading-7 tracking-tight sm:leading-10 md:text-4xl">
                        {{rol.tipologiaId != idRolAdministrador ? 'Actualizar Permisos': 'Permisos' }}
                    </div>
                    <div class="ml-0.5 font-medium text-secondary"></div>
                </div>
            </div>
            
        </div>

        <div class="w-full flex md:flex-row flex-col items-center justify-between mt-4 shrink-0">
            <span class="font-bold text-lg md:text-2xl">
                Permisos para el Rol: {{rol.descripcion}}
            </span>
        
            @if(rol.tipologiaId != idRolAdministrador){
                <button mat-flat-button 
                    [color]="'primary'" 
                    class="rounded-full px-4 w-full md:w-auto mt-2 md:mt-0"
                    type="submit"
                    (click)="actualizarPermisos()"
                >Actualizar Permisos
                </button>
            }
            

        </div>

        <div class="flex-1 overflow-y-auto mt-4">
            @for (permiso of permisos; track $index) {
                <div class="w-full mb-6 gap-4">
                    <div class="mt-4 w-full md:w-1/2">
                        <span class="text-lg md:text-xl font-semibold">
                        {{ permiso.nombreMenu }}
                        </span>
                        <hr class="my-2">

                        @for (opcion of permiso.options; track $index) {
                            <div class="w-full flex items-center justify-between py-1.5">
                            <label class="w-7/12 pr-4"  [matTooltip]="opcion.descripcion">{{ opcion.bloque }}</label>
                                <div class="border w-5/12 rounded-md p-2">
                                    <mat-select [(ngModel)]="opcion.habilitado">
                                        <mat-option [value]="true">Permitir</mat-option>
                                        <mat-option [value]="false">No Permitir</mat-option>
                                    </mat-select>
                                </div>
                            </div>
                        }

                    </div>
                </div>
            
            }
        </div>
        
    </div>
}